import React from "react";
import styles from "./Inline.module.css";

const gapClassMap = {
  "1": styles.gap1,
  "2": styles.gap2,
  "3": styles.gap3,
  "4": styles.gap4,
  "5": styles.gap5,
  "6": styles.gap6,
};

const alignClassMap = {
  start: styles.alignStart,
  center: styles.alignCenter,
  end: styles.alignEnd,
  stretch: styles.alignStretch,
};

const justifyClassMap = {
  start: styles.justifyStart,
  center: styles.justifyCenter,
  end: styles.justifyEnd,
  "space-between": styles.justifyBetween,
};

export default function Inline({
  children,
  gap = "3",
  align = "center",
  justify = "start",
  wrap = false,
  className = "",
}) {
  return (
    <div
      className={[
        styles.inline,
        gapClassMap[gap] || styles.gap3,
        alignClassMap[align] || styles.alignCenter,
        justifyClassMap[justify] || styles.justifyStart,
        wrap ? styles.wrap : "",
        className,
      ].join(" ")}
    >
      {children}
    </div>
  );
}